import { render, staticRenderFns } from "./FormPaymentCard.vue?vue&type=template&id=8b4648ba"
import script from "./FormPaymentCard.vue?vue&type=script&lang=js"
export * from "./FormPaymentCard.vue?vue&type=script&lang=js"
import style0 from "./FormPaymentCard.vue?vue&type=style&index=0&id=8b4648ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports